import React from 'react';
import { makeStyles, createStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { colors, fontSizes,fontFamily } from '../../styles/variables';


const useStyles = makeStyles(() =>
  createStyles({
  
    paper: {
      height: '100%',
      //width: '100%',
      minWidth:'30%',
      borderRadius:19,
      boxShadow:'none',
      paddingBottom:20,
      borderTopWidth:20,
      borderTopStyle:'solid',
      borderTopColor:'white',
      // transitionDuration: '0.4s',
      '&:hover':{
        borderTopWidth:20,
        borderTopColor:colors.red,
        borderTopStyle:'solid',
        boxShadow:'0px 0px 40px #0C20721A',
        color:colors.red,
        transition: 'all 3s',
      },
      '&:hover > p':{
        color:colors.red,
        transition: 'all 1s',
      },
    },
    featureItemImage:{
      width:60,
      justifyContent:'center',
      objectFit:'contain',
      position: 'relative'
    },
    featureItemImage2:{
      width:35,
      justifyContent:'center',
      objectFit:'contain',
      position: 'relative'
    },
    featureItemImageDiv:{
      display:'flex',
      paddingTop:60,
      paddingBottom:30,
      justifyContent:'center',
      alignContent:'center',
    },
    itemHeading:{
      fontFamily:fontFamily.poppins,
      fontSize:fontSizes.lg.small,
      fontWeight:'bolder',
      textAlign:'center',
      color:'black',
    },
    descriptionMain:{
      display:'flex',
      justifyContent:'center'
    },
    itemDescription:{
      fontFamily:fontFamily.poppins,
      fontSize:fontSizes.md.small,
      pading:'10em',
      fontWeight:'lighter',
      textAlign:'center',
      color: colors.black,
      lineHeight: 2,
      // paddingTop:20,
      paddingLeft:25,
      paddingRight:25,
      overflow:'hidden',
      height:90,
      margin:10
    },
    main:{
      '@media only screen and (max-width: 959px)': {
       marginLeft:50,
       marginRight:50
      },
    }
  }),
);

export default function FeatureCard(props:any) {
  const classes = useStyles();
  return (
     <Grid item spacing={2}  md={4} xl={3} sm={12}className={classes.main}>
       <Paper className={classes.paper}>
         <div className={classes.featureItemImageDiv}>
            {props.image2?
              <img src={props.image2} alt="featuresimage"  className={classes.featureItemImage2} onMouseOver={e => (e.currentTarget.src = props.image3)} onMouseOut={e => (e.currentTarget.src = props.image4)} />:
              <img src={props.image1} alt="featuresimage" className={classes.featureItemImage}onMouseOver={e => (e.currentTarget.src = props.image5)} onMouseOut={e => (e.currentTarget.src = props.image6)}/>
            }
         </div>
         <p className={classes.itemHeading}>{props.heading1}</p>
         <div className={classes.descriptionMain}>
         <div className={classes.itemDescription}>{props.description}</div>
         </div>
        
       </Paper>
     </Grid> 
      
  );
}
